import { GroupAssessmentStatsDTOS } from './group-assesment-stats';

export class GroupAssessmentSummary {
  groupAssessmentId: string;
  avgOfAttempts: number;
  groupAssessmentStatsDTOS: GroupAssessmentStatsDTOS[];

  constructor(stats?: Partial<GroupAssessmentSummary>) {
    Object.assign(this, stats);
  }
}
